import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { finalize, tap, catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

import { AuthenticationService } from '@service/authentication.service';
import { DocumentListService } from './document-list.service';

import { LoginDateTime, LoginHistory } from '@model/authentication.model';
import { DocumentList } from './document-list.model';

@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss']
})
export class DocumentListComponent implements OnInit {
  documentList: DocumentList[];
  isLoading: boolean;

  hasFailedLogin: boolean;
  successLoginTime: string;
  failLoginList: LoginDateTime[];

  errorMessage: string;

  constructor(
    private translateService: TranslateService,
    private documentListService: DocumentListService,
    private authenService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.getDocument();
    this.getLoginHistory();
  }

  openDocument(ePolicyId: string): void {
    window.open(`/document/${ePolicyId}`, '_blank');
  }

  isClaimNotiDocType(docType: string): boolean {
    return docType === 'CLAIM_NOTI';
  }

  private getDocument(): void {
    const lang: string = this.translateService.currentLang;
    const idType: string = this.authenService.getIdentityType();
    const idNumber: string = this.authenService.getIdentityNo();
    this.documentListService
      .getDocumentList(idType, idNumber, lang)
      .pipe(
        tap(
          (documentList: DocumentList[]) => {
            if (documentList) {
              this.documentList = documentList;
            } else {
              this.errorMessage = 'documentList.noData';
            }
          }
        ),
        catchError((e: Error) => {
          this.errorMessage = 'errors.unexpected';
          throw e;
        }),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe();
  }

  private getLoginHistory(): void {
    this.authenService
      .getLoginHistory()
      .pipe(
        tap(
          (history: LoginHistory) => {
            this.successLoginTime = history.lastLoginSuccess.loginDateTime;
            this.failLoginList = history.loginFail;
            this.hasFailedLogin = history.loginFail.length > 0;
          }
        ),
        catchError((e: HttpErrorResponse) => {
          this.hasFailedLogin = false;
          this.successLoginTime = null;
          throw e;
        })
      )
      .subscribe();
  }
}
